export const CoordinateSystems = [{
    name: 'PL-1992',
    epsg: 'EPSG:2180',
    minx: 125000,
    maxx: 800000,
    miny: 165000,
    maxy: 870000
  },
  {
    name: 'PL-2000 (Strefa V)',
    epsg: 'EPSG:2176',
    minx: 5418449.33,
    maxx: 6132385.78,
    miny: 5457982.49,
    maxy: 6125828.77
  },
  {
    name: 'PL-2000 (Strefa VI)',
    epsg: 'EPSG:2177',
    minx: 5424449.39,
    maxx: 6109563.61,
    miny: 6238075.72,
    maxy: 6934206.02
  },
  {
    name: 'PL-2000 (Strefa VII)',
    epsg: 'EPSG:2178',
    minx: 5439157.55,
    maxx: 6095041.13,
    miny: 7018267.57,
    maxy: 7742170.37
  },
  {
    name: 'PL-2000 (Strefa VIII)',
    epsg: 'EPSG:2179',
    minx: 5462638.18,
    maxx: 6088779.47,
    miny: 7798647.46,
    maxy: 8549907.79
  },
  {
    name: 'PL-1965 (Strefa I)',
    epsg: 'EPSG:3120',
    minx: 441168,
    maxx: 4862072,
    miny: 5294265,
    maxy: 5661128
  },
  {
    name: 'PL-1965 (Strefa II)',
    epsg: 'EPSG:2172',
    minx: 3803735,
    maxx: 4770188,
    miny: 5622773,
    maxy: 6044107
  },
  {
    name: 'PL-1965 (Strefa III)',
    epsg: 'EPSG:2173',
    minx: 3304926,
    maxx: 3705756.9892,
    miny: 5845694.0008,
    maxy: 6141849
  },
  {
    name: 'PL-1965 (Strefa IV)',
    epsg: 'EPSG:2174',
    minx: 3519047,
    maxx: 3878157,
    miny: 5369499,
    maxy: 5814600
  },
  {
    name: 'PL-1965 (Strefa V)',
    epsg: 'EPSG:2175',
    minx: 191452,
    maxx: 288852,
    miny: 766558,
    maxy: 989076
  },
  {
    name: 'PL-1942',
    epsg: 'EPSG:3329',
    minx: 6372215,
    maxx: 6628029,
    miny: 4441838,
    maxy: 6083928
  },
  {
    name: 'WGS84',
    epsg: 'EPSG:4326',
    minx: 14,
    maxx: 24.778513,
    miny: 48.901811,
    maxy: 54.925806
  }
];

export const FileDataFormats = [{
    name: "Shapefile",
    value: "shp"
  },
  {
    name: "GML",
    value: "gml"
  },
  {
    name: "KML",
    value: "kml"
  },
  {
    name: "GPX",
    value: "gpx"
  },
  {
    name: "GeoTIFF",
    value: "geotiff"
  },
  {
    name: "GeoJSON",
    value: "geojson"
  },
  {
    name: "DXF",
    value: "dxf"
  },
  {
    name: "DGN",
    value: "dgn"
  },
  {
    name: "DWG",
    value: "dwg"
  },
  {
    name: "TAB",
    value: "tab"
  },
  {
    name: "MIF",
    value: "mif"
  },
  {
    name: "GDB",
    value: "gdb"
  },
  {
    name: "MDB",
    value: "mdb"
  },
  {
    name: "CSV",
    value: "csv"
  },
  {
    name: "XML",
    value: "xml"
  }
];

export const FileCodingFormat = [{
    name: "UTF-8",
    value: "utf-8"
  },
  {
    name: "Windows 1250",
    value: "windows-1250"
  },
  {
    name: "ISO-8859-2",
    value: "iso-8859-2"
  }
];

export const FileCoordinateSystems = [{
    name: "PUWG92",
    value: "2180"
  },
  {
    name: "WGS84",
    value: "4326"
  },
  {
    name: "PL2000 V",
    value: "2176"
  },
  {
    name: "PL2000 VI",
    value: "2177"
  },
  {
    name: "PL2000 VII",
    value: "2178"
  },
  {
    name: "PL2000 VIII",
    value: "2179"
  }
];
